export default "__VITE_ASSET__EpYTJA9___"